
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stats/[id]",
      function () {
        return require("private-next-pages/stats/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stats/[id]"])
      });
    }
  